// extracted by mini-css-extract-plugin
module.exports = {"emptyPortfolioWrapper":"EvvllX1i","styledImg":"TseMV7zl","title":"QRQWjP0r","description":"uxuxrYG5","addAssetsButton":"icJyBVlA"};